module.exports = __webpack_public_path__ + "static/media/9_of_diamonds.f2c17e41.png";